import { useEffect, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { loadImage } from '../utils/imageUtils';
/**
 * A hook that waits until the provided imageUrl is loaded, then returns that URL and its dimensions.
 */
export function useLoadedImage(imageUrl) {
    const isMounted = useMountedState();
    const [loadedImageHookResult, setLoadedImageHookResult] = useState();
    useEffect(() => {
        async function effect() {
            const image = await loadImage(imageUrl);
            if (!isMounted()) {
                return;
            }
            setLoadedImageHookResult({ imageUrl, width: image.width, height: image.height });
        }
        effect();
    }, [imageUrl, isMounted]);
    return loadedImageHookResult;
}
